import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { environment } from '@libs/gc-common/environments/environment';
import { StoryModel } from '@libs/gc-common/lib/api/models/story';
import { UserModel } from '@libs/gc-common/lib/api/models/user';
import { RouterService } from '@libs/gc-common/lib/services/router';
import Swiper, { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';

interface StorySlideInterface {
  story: StoryModel;
  prevSlide?: StorySlideInterface;
  nextSlide?: StorySlideInterface;
  isIntoViewport: boolean;
  isAttached: boolean;
  hasFinished: boolean;
  isActive: boolean;
  index: number;
}

@Component({
  selector: 'mip-stories-slider',
  templateUrl: './stories-slider.component.html',
  styleUrls: ['./stories-slider.component.scss'],
})
export class StoriesSliderComponent implements OnInit, AfterViewInit, OnChanges {
  
  @Input() profile: UserModel;
  @Input() stories: StoryModel[] = [];
  @Input() isActive = true;
  
  @Output() lastSlideVideoEnded = new EventEmitter();
  
  @ViewChild('swiperContainer') swiperContainer: SwiperComponent;
  
  swiperConfig: SwiperOptions = {
    allowTouchMove: false,
    navigation: false,
  };
  
  currentIndex = 0;
  getGoBackUrl = null;
  slides: StorySlideInterface[] = [];
  currentSlide: StorySlideInterface;
  
  assetsPath = environment.assetsPath;
  swiperRef!: Swiper;
  
  constructor(private routerService: RouterService) {}
  
  ngOnInit() {
    const getGoBackReferer = this.routerService.getGoBackReferer();
    console.log('stories-slider.component->ngOnInit(): getGoBackReferer', getGoBackReferer);
    
    this.getGoBackUrl = getGoBackReferer ? getGoBackReferer.path : '/trending';
    console.log('stories-slider.component->ngOnInit(): this.getGoBackUrl', this.getGoBackUrl);
  }
  
  ngAfterViewInit() {
    this.swiperRef = this.swiperContainer.swiperRef;
    console.log('stories-slider.component->ngAfterViewInit(): this.swiperRef', this.swiperRef);
  }
  
  ngOnChanges(changes: SimpleChanges) {
    
    if (changes['stories']) {
      this.buildStoriesSlides();
    }
    
    console.log('stories-slider.component->ngOnChanges(): isActive', this.isActive, this.slides);
    
    if (changes['isActive'] && this.isActive) {
      for (const slide of this.slides) {
        slide.isIntoViewport = false;
        slide.isActive = false;
        slide.isAttached = false;
      }
      
      if (this.isActive) {
        if (this.currentSlide) {
          this.slideChange([{ activeIndex: this.currentSlide.index }]);
        }
        else {
          this.slideChange([{ activeIndex: 0 }]);
        }
      }
    }
    else if (this.isActive === false) {
      for (const slide of this.slides) {
        slide.isIntoViewport = false;
        slide.isActive = false;
        // slide.isAttached = false;
      }
    }
  }
  
  buildStoriesSlides() {
    let index = 0;
    const hasPreviouslySlides = this.slides.length > 0;
    
    for (const story of this.stories) {
      const slide = this.slides.find((item) => item.story.id === story.id);
      // console.log('stories-slider.component->buildStoriesSlides(): slide', slide);
      
      const prevSlide = this.slides[index - 1] || null;
      
      if (!slide) {
        const currentSlide: StorySlideInterface = {
          index,
          hasFinished: false,
          isIntoViewport: false,
          isAttached: false,
          isActive: false,
          story,
          prevSlide,
        };
        
        if (prevSlide) {
          prevSlide.nextSlide = currentSlide;
        }
        
        this.slides.push(currentSlide);
      }
      
      index++;
    }
    
    if (hasPreviouslySlides) {
      this.slideChange([{ activeIndex: 0 }]);
    }
    
    console.log('stories-slider.component->buildStoriesSlides(): this.slides', this.slides);
  }
  
  slideChange([{ activeIndex }]) {
    console.log('stories-slider.component->slideChange(): activeIndex', this.currentIndex, activeIndex);
    
    const slideDirection = activeIndex > this.currentIndex ? 'next' : 'prev';
    const slide = this.slides[activeIndex];
    this.currentSlide = slide;
    // console.log('stories-slider.component->slideChange(): slide', slide);
    
    slide.isIntoViewport = true;
    slide.isActive = true;
    slide.isAttached = true;
    slide.hasFinished = false;
    
    const { prevSlide, nextSlide } = slide;
    // console.log('stories-slider.component->slideChange(): { prevSlide, nextSlide }', { prevSlide, nextSlide });
    
    if (prevSlide) {
      prevSlide.isIntoViewport = false;
      let loopPrevSlide = prevSlide;
      
      while (loopPrevSlide) {
        console.log('stories-slider.component->slideChange(): loopPrevSlide', loopPrevSlide);
        
        loopPrevSlide.hasFinished = true;
        loopPrevSlide.isActive = false;
        loopPrevSlide = loopPrevSlide.prevSlide;
      }
      
      if (slideDirection === 'prev') {
        prevSlide.isAttached = true;
      }
      
      if (prevSlide.prevSlide) {
        prevSlide.prevSlide.isAttached = false;
      }
    }
    
    if (nextSlide) {
      nextSlide.isIntoViewport = false;
      let loopNextSlide = nextSlide;
      
      while (loopNextSlide) {
        console.log('stories-slider.component->slideChange(): loopNextSlide', loopNextSlide);
        
        loopNextSlide.hasFinished = false;
        loopNextSlide.isActive = false;
        loopNextSlide = loopNextSlide.nextSlide;
      }
      
      if (slideDirection === 'next') {
        nextSlide.isAttached = true;
      }
      
      if (nextSlide.nextSlide) {
        nextSlide.nextSlide.isAttached = false;
      }
    }
    
    console.log('stories-slider.component->slideChange(): this.slides', this.slides);
    
    this.currentIndex = activeIndex;
  }
  
  slidePrev() {
    console.log('stories-slider.component->slidePrev()');
    this.swiperRef.slidePrev();
  }
  
  slideNext(slide: StorySlideInterface) {
    console.log('stories-slider.component->slideNext(): slide', slide);
    
    if (slide.nextSlide) {
      this.swiperRef.slideNext();
    }
    else {
      this.lastSlideVideoEnded.emit();
    }
  }
}
